// extracted by mini-css-extract-plugin
export default {"group-mapping":"n6nEDdIe_sOx4Q5lFhw_","group-mapping-row":"iRZpdkYlNJWd0Ipdg2Kw","delete-action":"NzUnVJWW5K4oLOqWghYx","arrow-icon":"_FuaGziDnO7ZOJuej0Ba"};